import { render, staticRenderFns } from "./QaSearchForm.vue?vue&type=template&id=1abef108&scoped=true&"
import script from "@/scripts/QA/QuestionList/components/QaSearchForm?vue&type=script&lang=js&"
export * from "@/scripts/QA/QuestionList/components/QaSearchForm?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abef108",
  null
  
)

export default component.exports